import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IStateDefaults } from "../../types/shared";
import { ICoupon, IProduct } from "../../types/api";
import { IRegisterTeamForm } from "../../types/forms";
import { getProducts } from "./shopActions";
import { RootState } from "../../store";

interface ShopState extends IStateDefaults {
    cart: IRegisterTeamForm[];
    products: IProduct[];
    promoCode?: ICoupon;
}

const initialState: ShopState = {
    loading: false,
    success: false,
    cart: JSON.parse(localStorage.getItem("cart") || "[]"),
    promoCode: JSON.parse(localStorage.getItem("promoCode") || "{}"),
    products: [],
};

const shopSlice = createSlice({
    name: "shop",
    initialState,
    reducers: {
        addToCart: (state, action: PayloadAction<IRegisterTeamForm>) => {
            state.cart.push(action.payload);
            localStorage.setItem("cart", JSON.stringify(state.cart));
        },
        removeItem: (state, action: PayloadAction<IRegisterTeamForm>) => {
            state.cart = state.cart.filter(
                item => JSON.stringify(item) !== JSON.stringify(action.payload),
            );
            localStorage.setItem("cart", JSON.stringify(state.cart));
        },
        emptyCart: state => {
            state.cart = [];
            localStorage.setItem("cart", JSON.stringify(state.cart));
        },
        updatePromoCode: (state, action: PayloadAction<ICoupon["code"]>) => {
            state.cart.forEach(product => {
                product.promoCode = action.payload;
            });
            localStorage.setItem("cart", JSON.stringify(state.cart));
        },
        setPromoCode: (state, action: PayloadAction<ICoupon | undefined>) => {
            state.promoCode = action.payload;
            localStorage.setItem("promoCode", JSON.stringify(state.promoCode));
        },
        deletePromoCode: state => {
            state.promoCode = undefined;
            localStorage.removeItem("promoCode");
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getProducts.pending, state => {
                state.loading = true;
            })
            .addCase(getProducts.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.products = payload.products;
            })
            .addCase(getProducts.rejected, state => {
                state.loading = false;
            });
    },
});

export const shopActions = {
    ...shopSlice.actions,
    getProducts: getProducts,
};

export default shopSlice.reducer;

export const selectProducts = createSelector(
    [(state: RootState) => state.shop],
    shop => shop.products,
);

export const selectCart = createSelector(
    [(state: RootState) => state.shop],
    shop => shop.cart,
);
